import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useMedia } from 'react-use';
import { Icon, Typography } from 'ck-ui';
import classnames from 'classnames';
import styles from './Accordion.module.scss';

const Accordion = ({ title, content }) => {
  const isMobile = useMedia('(max-width: 767px)');
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className={styles.root}>
      <div
        role="button"
        tabIndex="0"
        className={styles.header}
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <span className={styles.left}>
          <Icon size={isMobile ? 'regular' : 'medium'} name="info" />
          <Typography variant={isMobile ? 'body-medium' : 'body-xlarge'} className={styles.title}>
            {title}
          </Typography>
        </span>

        <Icon name={isExpanded ? 'minus' : 'plus'} className={styles.icon} />
      </div>
      <div
        className={classnames(styles.content, { [styles.show]: isExpanded })}
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: content }}
      />
    </div>
  );
};

Accordion.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
};

export { Accordion };
